export default function(){
    var sleeknoteScriptTag = document.createElement("script");
    sleeknoteScriptTag.type = "text/javascript";
    sleeknoteScriptTag.charset = "utf-8";
    sleeknoteScriptTag.src = ("//sleeknotecustomerscripts.sleeknote.com/49170.js");
    document.querySelectorAll('head')[0].appendChild(sleeknoteScriptTag);
}